import { render, staticRenderFns } from "./user-icon.vue?vue&type=template&id=1c105b01&lang=pug"
import script from "./user-icon.vue?vue&type=script&lang=js"
export * from "./user-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports